<template>
  <div>
    <v-card tile elevation="0" class="item-card">
      <v-container fluid>
        <v-row justify="start">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >プレビュー保存</general-button
            >
          </v-col>
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onPreview"
              ><template v-slot:icon
                ><v-icon left>mdi-file-find</v-icon></template
              >プレビュー表示</general-button
            >
          </v-col>
          <v-col cols="6" sm="3">
            <general-button
              btn_type="accent"
              btn_block
              @click-event="onBackToCss"
              ><template v-slot:icon
                ><v-icon left>mdi-file-find</v-icon></template
              >サイトCSSから戻す</general-button
            >
          </v-col>
          <v-col cols="6" sm="3">
            <general-button btn_type="success" btn_block @click-event="onDeploy"
              ><template v-slot:icon><v-icon left>mdi-upload</v-icon></template
              >サイトCSSに反映</general-button
            >
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <h3>
              カスタムCSS
              <span v-if="showSaved" class="ml-2 text-red font-weight-bold mini"
                >保存しました</span
              >
            </h3>
            <div class="mt-2 mb-2">
              個別にCSSを指定して、サイトのデザインを調整できます。
            </div>
            <v-card tile elevation="0" class="mb-6">
              <div class="ma-3 editor-container">
                <codemirror
                  :ref="category_items.css_code_preview.ref"
                  v-model="category_items.css_code_preview.detail"
                  :options="cmOptions"
                />
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import {
  ref,
  set,
  reactive,
  toRefs,
  defineComponent,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import imageUploaderComponent from "./imageUploader.vue";
import retryRequest from "@/common/retryRequest";

import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/css/css.js";
import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/show-hint.js";
import "codemirror/addon/hint/css-hint.js";

export default defineComponent({
  components: {
    imageUploaderComponent,
    codemirror,
  },
  props: ["shop_site_id", "site_url"],
  setup(props, ctx) {
    const showSaved = ref(false);
    const HpListDetailRepository = repositoryFactory.get("hpListDetails");

    const refCssCode = ref(null);

    const data_id = 5; // CSS設定 5固定

    const state = reactive({
      // 入力項目カテゴリごとのデータ構造体
      category_items: {
        css_code_preview: {
          type: "css",
          ref: "refCssCode",
          category_num: 0, // 0固定
          category_code: "css_code_preview",
          name: "",
          detail: "",
        },
      },
    });
    const cmOptions = {
      mode: "text/css", // 言語モードをCSSに設定
      theme: "default", // テーマを設定
      lineNumbers: true, // 行番号を表示
      smartIndent: true, // スマートインデントを有効化
      extraKeys: { "Ctrl-Space": "autocomplete" },
      hintOptions: {
        completeSingle: false,
      },
    };

    onMounted(() => {
      // APIからデータを取得
      getListData();

      // 自動補完のイベントリスナーを設定
      if (refCssCode.value) {
        // myCm.valueでコンポーネントインスタンスにアクセス
        refCssCode.value.codemirror.on("inputRead", (cm, change) => {
          const typedText = change.text[0];
          if (typedText && /^[a-zA-Z-]$/.test(typedText)) {
            cm.showHint();
          }
        });
      }
    });

    const getListData = async () => {
      // サイト設定データ取得
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
      };
      const response = await retryRequest(
        HpListDetailRepository.list_data,
        params,
        true
      );
      if (response.data) {
        // 取得したデータをstateにセット
        for (const key of Object.keys(state.category_items)) {
          const item = state.category_items[key];
          const getItem = response.data.find(
            (i) => i.category_code === item.category_code
          );
          if (!getItem) continue; // 該当データがない場合はスキップ

          item.name = getItem.name || "";
          item.detail = getItem.detail || "";
        }
      }

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    onMounted(() => {
      getListData();
    });

    const onSubmit = async () => {
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
        category_num: state.category_items.css_code_preview.category_num,
        category_code: state.category_items.css_code_preview.category_code,
        name: state.category_items.css_code_preview.name,
        detail: state.category_items.css_code_preview.detail,
      };
      await HpListDetailRepository.save_css_preview(params)
        .then((response) => {
          if (response.data) {
            // 保存OK(5秒間だけ保存完了メッセージを表示)
            showSaved.value = true;
            setTimeout(() => {
              showSaved.value = false;
            }, 3000);
          }
        })
        .catch((error) => {
          throw "ERROR:HpListDetailRepository.save_list (" + error + ")";
        });

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    const onPreview = async () => {
      await onSubmit();
      // サイトを開く
      if (!props.site_url) {
        alert("サイトURLが取得できませんでした。");
        return;
      }
      const previewUrl = `${props.site_url}?preview=true`;
      window.open(previewUrl, "sitePreviewTab");
    };

    const onDeploy = async () => {
      // サイトに反映処理
      if (
        !window.confirm(
          "プレビューに保存してあるCSSをサイトに反映してよろしいですか？"
        )
      ) {
        return false;
      }

      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
      };
      await HpListDetailRepository.deploy_css(params)
        .then((response) => {
          if (response.data) {
            // 反映OK
            if (response.data.result === true) {
              alert("サイトに反映しました。");
            } else {
              alert("プレビューが保存されていません。");
            }
          }
        })
        .catch((error) => {
          throw "ERROR:HpListDetailRepository.deploy_css (" + error + ")";
        });

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");

      getListData(); // データを再取得して最新の状態に更新
    };

    const onBackToCss = async () => {
      // サイトに反映処理
      if (!window.confirm("サイトのCSSから戻します。よろしいですか？")) {
        return false;
      }

      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
      };
      await HpListDetailRepository.back_to_css(params)
        .then((response) => {
          if (response.data) {
            // 反映OK
            if (response.data.result === true) {
              alert("サイトのCSSから戻しました。");
            } else {
              alert("サイトCSSがありません。");
            }
          }
        })
        .catch((error) => {
          throw "ERROR:HpListDetailRepository.deploy_css (" + error + ")";
        });

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");

      getListData(); // データを再取得して最新の状態に更新
    };

    // 返却オブジェクト定義
    return {
      showSaved,
      refCssCode,
      setting,
      cmOptions,
      ...toRefs(state),
      onSubmit,
      onPreview,
      onDeploy,
      onBackToCss,
    };
  },
});
</script>

<style scoped>
.editor-container {
  border: 1px solid #ccc;
  border-radius: 4px; /* 角を少し丸くすると綺麗に見えます */
}
.editor-container >>> .CodeMirror {
  height: 600px;
}
</style>
